module.exports = __webpack_public_path__ + "static/media/5v5ide_gif.9db1b39c.gif";